/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /** @jsx html */
	
	var _promisePolyfill = __webpack_require__(1);
	
	var _promisePolyfill2 = _interopRequireDefault(_promisePolyfill);
	
	__webpack_require__(5);
	
	var _snabbdomJsx = __webpack_require__(6);
	
	var _snabbdom = __webpack_require__(7);
	
	var _redux = __webpack_require__(15);
	
	var _api = __webpack_require__(36);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _selectCompetition = __webpack_require__(38);
	
	var _selectCompetition2 = _interopRequireDefault(_selectCompetition);
	
	var _selectPlayers = __webpack_require__(39);
	
	var _selectPlayers2 = _interopRequireDefault(_selectPlayers);
	
	var _resultsTable = __webpack_require__(93);
	
	var _resultsTable2 = _interopRequireDefault(_resultsTable);
	
	var _util = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	if (!window.Promise) window.Promise = _promisePolyfill2.default;
	
	var reducers = {
	  loading: function loading(state, action) {
	    switch (action.type) {
	      case 'FETCH_RESULTS_REQ':
	        return true;
	      case 'FETCH_RESULTS_RES':
	      case 'FETCH_RESULTS_ERR':
	        return false;
	      default:
	        return state;
	    }
	  },
	  data: function data(state, action) {
	    switch (action.type) {
	      case 'FETCH_RESULTS_RES':
	        var gotCompetitionData = !!(0, _util.getDeepProp)(action, 'response.Competition');
	
	        if (!gotCompetitionData) alert(window.discgolfmetrixResults.l10n.missing_data_error);
	
	        return !gotCompetitionData ? state : _extends({}, state, {
	          results: action.response
	        });
	      case 'FETCH_FILTER_RES':
	        var gotFilterData = !!(0, _util.getDeepProp)(action, 'response.competitions');
	
	        // if (!gotFilterData)
	        //   alert(window.discgolfmetrixResults.l10n.missing_data_error)
	
	        return !gotFilterData ? state : _extends({}, state, {
	          filters: action.response
	        });
	      case 'FETCH_RESULTS_ERR':
	      case 'FETCH_FILTER_ERR':
	      // alert(window.discgolfmetrixResults.l10n.network_error)
	      default:
	        return state;
	    }
	  },
	  filters: function filters(state, action) {
	    if (action.type != 'FILTER') return state;
	
	    var newState = {};
	
	    // Reset all filters (two filters cannot be active at the same time)
	    for (var name in state) {
	      newState[name] = name == 'players' ? { selected: 'all', lastChanged: Date.now() } : 'all';
	    }return _extends({}, newState, action.payload);
	  }
	};
	
	var Results = function () {
	  function Results(el, state) {
	    var _this = this;
	
	    _classCallCheck(this, Results);
	
	    this.onCompetitionSelect = function (competitionId) {
	      var external = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      /**
	       * Select competition if this callback is not called from
	       * this.competitionSelect (eg. click on competition name in tour summary
	       * table head).
	       */
	      if (external && _this.competitionSelect) for (var i = 0; i < _this.competitionSelect.competitions.length; i++) {
	        if (_this.competitionSelect.competitions[i].dataset.id == competitionId) _this.competitionSelect.selectCompetition(_this.competitionSelect.competitions[i]);
	      } // clear filters
	      _this.store.dispatch({
	        type: 'FILTER',
	        payload: {}
	      });
	      // get results data
	      _this.store.dispatch({
	        type: 'API_REQ',
	        payload: {
	          types: ['FETCH_RESULTS_REQ', 'FETCH_RESULTS_RES', 'FETCH_RESULTS_ERR'],
	          query: 'content=result&id=' + competitionId
	        }
	      });
	      // get filters data
	      _this.store.dispatch({
	        type: 'API_REQ',
	        payload: {
	          types: ['FETCH_FILTER_REQ', 'FETCH_FILTER_RES', 'FETCH_FILTER_ERR'],
	          query: 'content=wordpress_filters&competition_id=' + competitionId
	        }
	      });
	    };
	
	    this.el = el;
	    this.competitionId = this.el.dataset.competitionId;
	    this.store = (0, _redux.createStore)(function (state, action) {
	      return {
	        loading: reducers.loading(state.loading, action),
	        data: reducers.data(state.data, action),
	        filters: reducers.filters(state.filters, action)
	      };
	    }, this.getInitialState(state), (0, _redux.applyMiddleware)(_api2.default));
	
	    this.store.subscribe(function () {
	      return _this.setState(_this.store.getState());
	    });
	    this.setState(this.store.getState());
	    this.refetchInSeconds(30);
	  }
	
	  _createClass(Results, [{
	    key: 'getInitialState',
	    value: function getInitialState(state) {
	      return {
	        loading: false,
	        data: state,
	        filters: this.initFilters(state.filters_selected, state.filters)
	      };
	    }
	  }, {
	    key: 'setState',
	    value: function setState(state) {
	      this.state = _extends({}, this.state, state);
	      this.render();
	    }
	  }, {
	    key: 'initFilters',
	    value: function initFilters(filtersSelected, filters) {
	      var _this2 = this;
	
	      var state = {};
	      this.filters = {};
	
	      filtersSelected.forEach(function (name) {
	        if (name != 'competitions') {
	          var container = _this2.el.querySelector('.discgolfmetrix-results-filter-control-select-' + name);
	          var select = container.querySelector('select[name="' + name + '"]');
	
	          _this2.filters[name] = { container: container, select: select };
	
	          if (name == 'players') state[name] = {
	            selected: (0, _util.getMultiSelectValue)(select),
	            lastChanged: Date.now()
	          };else state[name] = select.value;
	        }
	      });
	
	      return state;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _getDeepProp = (0, _util.getDeepProp)(this.state, 'data.results.Competition'),
	          ID = _getDeepProp.ID;
	
	      if (ID && ID != this.competitionId) {
	        this.refetchInSeconds(30);
	        this.competitionId = ID;
	      }
	
	      if (!this.table) this.table = new _resultsTable2.default(this.el.querySelector('.discgolfmetrix-results-table'), this.state, this.onCompetitionSelect);else this.table.setState(this.state);
	
	      if (!this.competitionSelect) this.competitionSelect = new _selectCompetition2.default(this.el.querySelector('.discgolfmetrix-select-competitions'), this.onCompetitionSelect);
	
	      for (var name in this.filters) {
	        if (name == 'players') this.playersFilter ? this.playersFilter.setState(this.state) : this.playersFilter = new _selectPlayers2.default(this.filters[name], this.state, this.store);else this.renderFilter(name);
	      }
	    }
	  }, {
	    key: 'renderFilter',
	    value: function renderFilter(name) {
	      var _ref;
	
	      var selected = this.state.filters[name];
	      var options = (0, _util.getDeepProp)(this.state, ['data', 'filters', name]);
	      var container = (0, _snabbdomJsx.html)(
	        'div',
	        { 'class': (_ref = {}, _defineProperty(_ref, 'discgolfmetrix-results-filter-control-select-' + name, 1), _defineProperty(_ref, 'no-options', !Array.isArray(options) || !options.length), _ref) },
	        (0, _snabbdomJsx.html)(
	          'select',
	          { name: name, 'on-change': this.onChangeFilter.bind(this, name) },
	          (0, _snabbdomJsx.html)(
	            'option',
	            { value: 'all', selected: selected == 'all' },
	            window.discgolfmetrixResults.l10n.all[name]
	          ),
	          !Array.isArray(options) ? '' : options.map(function (option) {
	            var value = name == 'groups' ? option.Number : option.Name;
	            return (0, _snabbdomJsx.html)(
	              'option',
	              { value: value, selected: selected == value },
	              value
	            );
	          })
	        )
	      );
	
	      /* clear SSR select before patching in a vnode */
	      if (this.filters[name].container instanceof Element) this.filters[name].container.innerHTML = '';
	
	      this.filters[name].container = (0, _snabbdom.patch)(this.filters[name].container, container);
	    }
	  }, {
	    key: 'onChangeFilter',
	    value: function onChangeFilter(name, evt) {
	      this.store.dispatch({
	        type: 'FILTER',
	        payload: _defineProperty({}, name, evt.target.value)
	      });
	    }
	  }, {
	    key: 'refetchInSeconds',
	    value: function refetchInSeconds(secs) {
	      var _this3 = this;
	
	      clearTimeout(this.refetchTimer);
	      this.refetchTimer = setTimeout(function () {
	        var _getDeepProp2 = (0, _util.getDeepProp)(_this3.state, 'data.results.Competition'),
	            ID = _getDeepProp2.ID;
	
	        if (ID) _this3.store.dispatch({
	          type: 'API_REQ',
	          payload: {
	            types: ['FETCH_RESULTS_REQ', 'FETCH_RESULTS_RES', 'FETCH_RESULTS_ERR'],
	            query: 'content=result&id=' + ID
	          }
	        });
	
	        _this3.refetchInSeconds(secs);
	      }, secs * 1000);
	    }
	  }]);
	
	  return Results;
	}();
	
	var discgolfmetrixResults = document.querySelectorAll('.discgolfmetrix-results');
	for (var i = 0; i < discgolfmetrixResults.length; i++) {
	  var resultsData = void 0;
	  try {
	    resultsData = JSON.parse(discgolfmetrixResults[i].querySelector('.discgolfmetrix-results-data').innerHTML);
	  } catch (err) {
	    console.error('Could not parse results data. This could mean there was a network error when getting the data from Disc Golf Metrix data API.\n', err);
	    break;
	  }
	  new Results(discgolfmetrixResults[i], resultsData);
	}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {(function (root) {
	
	  // Store setTimeout reference so promise-polyfill will be unaffected by
	  // other code modifying setTimeout (like sinon.useFakeTimers())
	  var setTimeoutFunc = setTimeout;
	
	  function noop() {}
	  
	  // Polyfill for Function.prototype.bind
	  function bind(fn, thisArg) {
	    return function () {
	      fn.apply(thisArg, arguments);
	    };
	  }
	
	  function Promise(fn) {
	    if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
	    if (typeof fn !== 'function') throw new TypeError('not a function');
	    this._state = 0;
	    this._handled = false;
	    this._value = undefined;
	    this._deferreds = [];
	
	    doResolve(fn, this);
	  }
	
	  function handle(self, deferred) {
	    while (self._state === 3) {
	      self = self._value;
	    }
	    if (self._state === 0) {
	      self._deferreds.push(deferred);
	      return;
	    }
	    self._handled = true;
	    Promise._immediateFn(function () {
	      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
	      if (cb === null) {
	        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
	        return;
	      }
	      var ret;
	      try {
	        ret = cb(self._value);
	      } catch (e) {
	        reject(deferred.promise, e);
	        return;
	      }
	      resolve(deferred.promise, ret);
	    });
	  }
	
	  function resolve(self, newValue) {
	    try {
	      // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	      if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
	      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
	        var then = newValue.then;
	        if (newValue instanceof Promise) {
	          self._state = 3;
	          self._value = newValue;
	          finale(self);
	          return;
	        } else if (typeof then === 'function') {
	          doResolve(bind(then, newValue), self);
	          return;
	        }
	      }
	      self._state = 1;
	      self._value = newValue;
	      finale(self);
	    } catch (e) {
	      reject(self, e);
	    }
	  }
	
	  function reject(self, newValue) {
	    self._state = 2;
	    self._value = newValue;
	    finale(self);
	  }
	
	  function finale(self) {
	    if (self._state === 2 && self._deferreds.length === 0) {
	      Promise._immediateFn(function() {
	        if (!self._handled) {
	          Promise._unhandledRejectionFn(self._value);
	        }
	      });
	    }
	
	    for (var i = 0, len = self._deferreds.length; i < len; i++) {
	      handle(self, self._deferreds[i]);
	    }
	    self._deferreds = null;
	  }
	
	  function Handler(onFulfilled, onRejected, promise) {
	    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	    this.promise = promise;
	  }
	
	  /**
	   * Take a potentially misbehaving resolver function and make sure
	   * onFulfilled and onRejected are only called once.
	   *
	   * Makes no guarantees about asynchrony.
	   */
	  function doResolve(fn, self) {
	    var done = false;
	    try {
	      fn(function (value) {
	        if (done) return;
	        done = true;
	        resolve(self, value);
	      }, function (reason) {
	        if (done) return;
	        done = true;
	        reject(self, reason);
	      });
	    } catch (ex) {
	      if (done) return;
	      done = true;
	      reject(self, ex);
	    }
	  }
	
	  Promise.prototype['catch'] = function (onRejected) {
	    return this.then(null, onRejected);
	  };
	
	  Promise.prototype.then = function (onFulfilled, onRejected) {
	    var prom = new (this.constructor)(noop);
	
	    handle(this, new Handler(onFulfilled, onRejected, prom));
	    return prom;
	  };
	
	  Promise.all = function (arr) {
	    var args = Array.prototype.slice.call(arr);
	
	    return new Promise(function (resolve, reject) {
	      if (args.length === 0) return resolve([]);
	      var remaining = args.length;
	
	      function res(i, val) {
	        try {
	          if (val && (typeof val === 'object' || typeof val === 'function')) {
	            var then = val.then;
	            if (typeof then === 'function') {
	              then.call(val, function (val) {
	                res(i, val);
	              }, reject);
	              return;
	            }
	          }
	          args[i] = val;
	          if (--remaining === 0) {
	            resolve(args);
	          }
	        } catch (ex) {
	          reject(ex);
	        }
	      }
	
	      for (var i = 0; i < args.length; i++) {
	        res(i, args[i]);
	      }
	    });
	  };
	
	  Promise.resolve = function (value) {
	    if (value && typeof value === 'object' && value.constructor === Promise) {
	      return value;
	    }
	
	    return new Promise(function (resolve) {
	      resolve(value);
	    });
	  };
	
	  Promise.reject = function (value) {
	    return new Promise(function (resolve, reject) {
	      reject(value);
	    });
	  };
	
	  Promise.race = function (values) {
	    return new Promise(function (resolve, reject) {
	      for (var i = 0, len = values.length; i < len; i++) {
	        values[i].then(resolve, reject);
	      }
	    });
	  };
	
	  // Use polyfill for setImmediate for performance gains
	  Promise._immediateFn = (typeof setImmediate === 'function' && function (fn) { setImmediate(fn); }) ||
	    function (fn) {
	      setTimeoutFunc(fn, 0);
	    };
	
	  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
	    if (typeof console !== 'undefined' && console) {
	      console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
	    }
	  };
	
	  /**
	   * Set the immediate function to execute callbacks
	   * @param fn {function} Function to execute
	   * @deprecated
	   */
	  Promise._setImmediateFn = function _setImmediateFn(fn) {
	    Promise._immediateFn = fn;
	  };
	
	  /**
	   * Change the function to execute on unhandled rejection
	   * @param {function} fn Function to execute on unhandled rejection
	   * @deprecated
	   */
	  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
	    Promise._unhandledRejectionFn = fn;
	  };
	  
	  if (typeof module !== 'undefined' && module.exports) {
	    module.exports = Promise;
	  } else if (!root.Promise) {
	    root.Promise = Promise;
	  }
	
	})(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).setImmediate))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(3);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(4)))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Throttle resize event.
	 * @source developer.mozilla.org/en-US/docs/Web/Events/resize#requestAnimationFrame
	 */
	window.optimizedResize = function () {
	  var callbacks = [];
	  var running = false;
	
	  function resize() {
	    if (!running) {
	      running = true;
	
	      if (window.requestAnimationFrame) window.requestAnimationFrame(runCallbacks);else setTimeout(runCallbacks, 66);
	    }
	  }
	
	  function runCallbacks() {
	    callbacks.forEach(function (callback) {
	      callback();
	    });
	
	    running = false;
	  }
	
	  function addCallback(callback) {
	    if (callback) callbacks.push(callback);
	  }
	
	  return {
	    add: function add(callback) {
	      if (!callbacks.length) window.addEventListener('resize', resize);
	
	      addCallback(callback);
	    },
	    remove: function remove(callback) {
	      var callbackIdx = callbacks.indexOf(callback);
	
	      if (callbackIdx < 0) return;
	
	      callbacks.splice(callbackIdx, 1);
	
	      if (!callbacks.length) window.removeEventListener('resize', resize);
	    }
	  };
	}();

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	"use strict";
	
	var SVGNS = 'http://www.w3.org/2000/svg';
	var modulesNS = ['hook', 'on', 'style', 'class', 'props', 'attrs'];
	var slice = Array.prototype.slice;
	
	function isPrimitive(val) {
	  return  typeof val === 'string'   ||
	          typeof val === 'number'   ||
	          typeof val === 'boolean'  ||
	          typeof val === 'symbol'   ||
	          val === null              ||
	          val === undefined;
	}
	
	function normalizeAttrs(attrs, nsURI, defNS, modules) {
	  var map = { ns: nsURI };
	  for (var i = 0, len = modules.length; i < len; i++) {
	    var mod = modules[i];
	    if(attrs[mod])
	      map[mod] = attrs[mod];
	  }
	  for(var key in attrs) {
	    if(key !== 'key' && key !== 'classNames' && key !== 'selector') {
	      var idx = key.indexOf('-');
	      if(idx > 0)
	        addAttr(key.slice(0, idx), key.slice(idx+1), attrs[key]);
	      else if(!map[key])
	        addAttr(defNS, key, attrs[key]);
	    }
	  }
	  return map;
	
	  function addAttr(namespace, key, val) {
	    var ns = map[namespace] || (map[namespace] = {});
	    ns[key] = val;
	  }
	}
	
	function buildFromStringTag(nsURI, defNS, modules, tag, attrs, children) {
	
	  if(attrs.selector) {
	    tag = tag + attrs.selector;
	  }
	  if(attrs.classNames) {
	    var cns = attrs.classNames;
	    tag = tag + '.' + (
	      Array.isArray(cns) ? cns.join('.') : cns.replace(/\s+/g, '.')
	    );
	  }
	
	  return {
	    sel       : tag,
	    data      : normalizeAttrs(attrs, nsURI, defNS, modules),
	    children  : children.map( function(c) {
	      return isPrimitive(c) ? {text: c} : c;
	    }),
	    key: attrs.key
	  };
	}
	
	function buildFromComponent(nsURI, defNS, modules, tag, attrs, children) {
	  var res;
	  if(typeof tag === 'function')
	    res = tag(attrs, children);
	  else if(tag && typeof tag.view === 'function')
	    res = tag.view(attrs, children);
	  else if(tag && typeof tag.render === 'function')
	    res = tag.render(attrs, children);
	  else
	    throw "JSX tag must be either a string, a function or an object with 'view' or 'render' methods";
	  res.key = attrs.key;
	  return res;
	}
	
	function flatten(nested, start, flat) {
	  for (var i = start, len = nested.length; i < len; i++) {
	    var item = nested[i];
	    if (Array.isArray(item)) {
	      flatten(item, 0, flat);
	    } else {
	      flat.push(item);
	    }
	  }
	}
	
	function maybeFlatten(array) {
	  if (array) {
	    for (var i = 0, len = array.length; i < len; i++) {
	      if (Array.isArray(array[i])) {
	        var flat = array.slice(0, i);
	        flatten(array, i, flat);
	        array = flat;
	        break;
	      }
	    }
	  }
	  return array;
	}
	
	function buildVnode(nsURI, defNS, modules, tag, attrs, children) {
	  attrs = attrs || {};
	  children = maybeFlatten(children);
	  if(typeof tag === 'string') {
	    return buildFromStringTag(nsURI, defNS, modules, tag, attrs, children)
	  } else {
	    return buildFromComponent(nsURI, defNS, modules, tag, attrs, children)
	  }
	}
	
	function JSX(nsURI, defNS, modules) {
	  return function jsxWithCustomNS(tag, attrs, children) {
	    if(arguments.length > 3 || !Array.isArray(children))
	      children = slice.call(arguments, 2);
	    return buildVnode(nsURI, defNS || 'props', modules || modulesNS, tag, attrs, children);
	  };
	}
	
	module.exports = {
	  html: JSX(undefined),
	  svg: JSX(SVGNS, 'attrs'),
	  JSX: JSX
	};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.patch = undefined;
	
	var _snabbdom = __webpack_require__(8);
	
	var _snabbdom2 = _interopRequireDefault(_snabbdom);
	
	var _class = __webpack_require__(12);
	
	var _class2 = _interopRequireDefault(_class);
	
	var _props = __webpack_require__(13);
	
	var _props2 = _interopRequireDefault(_props);
	
	var _eventlisteners = __webpack_require__(14);
	
	var _eventlisteners2 = _interopRequireDefault(_eventlisteners);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patch = exports.patch = _snabbdom2.default.init([_class2.default, _props2.default,
	// snabbdomStyle,
	_eventlisteners2.default]);
	// import snabbdomStyle      from 'snabbdom/modules/style'

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	// jshint newcap: false
	/* global require, module, document, Node */
	'use strict';
	
	var VNode = __webpack_require__(9);
	var is = __webpack_require__(10);
	var domApi = __webpack_require__(11);
	
	function isUndef(s) { return s === undefined; }
	function isDef(s) { return s !== undefined; }
	
	var emptyNode = VNode('', {}, [], undefined, undefined);
	
	function sameVnode(vnode1, vnode2) {
	  return vnode1.key === vnode2.key && vnode1.sel === vnode2.sel;
	}
	
	function createKeyToOldIdx(children, beginIdx, endIdx) {
	  var i, map = {}, key;
	  for (i = beginIdx; i <= endIdx; ++i) {
	    key = children[i].key;
	    if (isDef(key)) map[key] = i;
	  }
	  return map;
	}
	
	var hooks = ['create', 'update', 'remove', 'destroy', 'pre', 'post'];
	
	function init(modules, api) {
	  var i, j, cbs = {};
	
	  if (isUndef(api)) api = domApi;
	
	  for (i = 0; i < hooks.length; ++i) {
	    cbs[hooks[i]] = [];
	    for (j = 0; j < modules.length; ++j) {
	      if (modules[j][hooks[i]] !== undefined) cbs[hooks[i]].push(modules[j][hooks[i]]);
	    }
	  }
	
	  function emptyNodeAt(elm) {
	    var id = elm.id ? '#' + elm.id : '';
	    var c = elm.className ? '.' + elm.className.split(' ').join('.') : '';
	    return VNode(api.tagName(elm).toLowerCase() + id + c, {}, [], undefined, elm);
	  }
	
	  function createRmCb(childElm, listeners) {
	    return function() {
	      if (--listeners === 0) {
	        var parent = api.parentNode(childElm);
	        api.removeChild(parent, childElm);
	      }
	    };
	  }
	
	  function createElm(vnode, insertedVnodeQueue) {
	    var i, data = vnode.data;
	    if (isDef(data)) {
	      if (isDef(i = data.hook) && isDef(i = i.init)) {
	        i(vnode);
	        data = vnode.data;
	      }
	    }
	    var elm, children = vnode.children, sel = vnode.sel;
	    if (isDef(sel)) {
	      // Parse selector
	      var hashIdx = sel.indexOf('#');
	      var dotIdx = sel.indexOf('.', hashIdx);
	      var hash = hashIdx > 0 ? hashIdx : sel.length;
	      var dot = dotIdx > 0 ? dotIdx : sel.length;
	      var tag = hashIdx !== -1 || dotIdx !== -1 ? sel.slice(0, Math.min(hash, dot)) : sel;
	      elm = vnode.elm = isDef(data) && isDef(i = data.ns) ? api.createElementNS(i, tag)
	                                                          : api.createElement(tag);
	      if (hash < dot) elm.id = sel.slice(hash + 1, dot);
	      if (dotIdx > 0) elm.className = sel.slice(dot + 1).replace(/\./g, ' ');
	      if (is.array(children)) {
	        for (i = 0; i < children.length; ++i) {
	          api.appendChild(elm, createElm(children[i], insertedVnodeQueue));
	        }
	      } else if (is.primitive(vnode.text)) {
	        api.appendChild(elm, api.createTextNode(vnode.text));
	      }
	      for (i = 0; i < cbs.create.length; ++i) cbs.create[i](emptyNode, vnode);
	      i = vnode.data.hook; // Reuse variable
	      if (isDef(i)) {
	        if (i.create) i.create(emptyNode, vnode);
	        if (i.insert) insertedVnodeQueue.push(vnode);
	      }
	    } else {
	      elm = vnode.elm = api.createTextNode(vnode.text);
	    }
	    return vnode.elm;
	  }
	
	  function addVnodes(parentElm, before, vnodes, startIdx, endIdx, insertedVnodeQueue) {
	    for (; startIdx <= endIdx; ++startIdx) {
	      api.insertBefore(parentElm, createElm(vnodes[startIdx], insertedVnodeQueue), before);
	    }
	  }
	
	  function invokeDestroyHook(vnode) {
	    var i, j, data = vnode.data;
	    if (isDef(data)) {
	      if (isDef(i = data.hook) && isDef(i = i.destroy)) i(vnode);
	      for (i = 0; i < cbs.destroy.length; ++i) cbs.destroy[i](vnode);
	      if (isDef(i = vnode.children)) {
	        for (j = 0; j < vnode.children.length; ++j) {
	          invokeDestroyHook(vnode.children[j]);
	        }
	      }
	    }
	  }
	
	  function removeVnodes(parentElm, vnodes, startIdx, endIdx) {
	    for (; startIdx <= endIdx; ++startIdx) {
	      var i, listeners, rm, ch = vnodes[startIdx];
	      if (isDef(ch)) {
	        if (isDef(ch.sel)) {
	          invokeDestroyHook(ch);
	          listeners = cbs.remove.length + 1;
	          rm = createRmCb(ch.elm, listeners);
	          for (i = 0; i < cbs.remove.length; ++i) cbs.remove[i](ch, rm);
	          if (isDef(i = ch.data) && isDef(i = i.hook) && isDef(i = i.remove)) {
	            i(ch, rm);
	          } else {
	            rm();
	          }
	        } else { // Text node
	          api.removeChild(parentElm, ch.elm);
	        }
	      }
	    }
	  }
	
	  function updateChildren(parentElm, oldCh, newCh, insertedVnodeQueue) {
	    var oldStartIdx = 0, newStartIdx = 0;
	    var oldEndIdx = oldCh.length - 1;
	    var oldStartVnode = oldCh[0];
	    var oldEndVnode = oldCh[oldEndIdx];
	    var newEndIdx = newCh.length - 1;
	    var newStartVnode = newCh[0];
	    var newEndVnode = newCh[newEndIdx];
	    var oldKeyToIdx, idxInOld, elmToMove, before;
	
	    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
	      if (isUndef(oldStartVnode)) {
	        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
	      } else if (isUndef(oldEndVnode)) {
	        oldEndVnode = oldCh[--oldEndIdx];
	      } else if (sameVnode(oldStartVnode, newStartVnode)) {
	        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
	        oldStartVnode = oldCh[++oldStartIdx];
	        newStartVnode = newCh[++newStartIdx];
	      } else if (sameVnode(oldEndVnode, newEndVnode)) {
	        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
	        oldEndVnode = oldCh[--oldEndIdx];
	        newEndVnode = newCh[--newEndIdx];
	      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
	        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
	        api.insertBefore(parentElm, oldStartVnode.elm, api.nextSibling(oldEndVnode.elm));
	        oldStartVnode = oldCh[++oldStartIdx];
	        newEndVnode = newCh[--newEndIdx];
	      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
	        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
	        api.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
	        oldEndVnode = oldCh[--oldEndIdx];
	        newStartVnode = newCh[++newStartIdx];
	      } else {
	        if (isUndef(oldKeyToIdx)) oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
	        idxInOld = oldKeyToIdx[newStartVnode.key];
	        if (isUndef(idxInOld)) { // New element
	          api.insertBefore(parentElm, createElm(newStartVnode, insertedVnodeQueue), oldStartVnode.elm);
	          newStartVnode = newCh[++newStartIdx];
	        } else {
	          elmToMove = oldCh[idxInOld];
	          patchVnode(elmToMove, newStartVnode, insertedVnodeQueue);
	          oldCh[idxInOld] = undefined;
	          api.insertBefore(parentElm, elmToMove.elm, oldStartVnode.elm);
	          newStartVnode = newCh[++newStartIdx];
	        }
	      }
	    }
	    if (oldStartIdx > oldEndIdx) {
	      before = isUndef(newCh[newEndIdx+1]) ? null : newCh[newEndIdx+1].elm;
	      addVnodes(parentElm, before, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
	    } else if (newStartIdx > newEndIdx) {
	      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
	    }
	  }
	
	  function patchVnode(oldVnode, vnode, insertedVnodeQueue) {
	    var i, hook;
	    if (isDef(i = vnode.data) && isDef(hook = i.hook) && isDef(i = hook.prepatch)) {
	      i(oldVnode, vnode);
	    }
	    var elm = vnode.elm = oldVnode.elm, oldCh = oldVnode.children, ch = vnode.children;
	    if (oldVnode === vnode) return;
	    if (!sameVnode(oldVnode, vnode)) {
	      var parentElm = api.parentNode(oldVnode.elm);
	      elm = createElm(vnode, insertedVnodeQueue);
	      api.insertBefore(parentElm, elm, oldVnode.elm);
	      removeVnodes(parentElm, [oldVnode], 0, 0);
	      return;
	    }
	    if (isDef(vnode.data)) {
	      for (i = 0; i < cbs.update.length; ++i) cbs.update[i](oldVnode, vnode);
	      i = vnode.data.hook;
	      if (isDef(i) && isDef(i = i.update)) i(oldVnode, vnode);
	    }
	    if (isUndef(vnode.text)) {
	      if (isDef(oldCh) && isDef(ch)) {
	        if (oldCh !== ch) updateChildren(elm, oldCh, ch, insertedVnodeQueue);
	      } else if (isDef(ch)) {
	        if (isDef(oldVnode.text)) api.setTextContent(elm, '');
	        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
	      } else if (isDef(oldCh)) {
	        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
	      } else if (isDef(oldVnode.text)) {
	        api.setTextContent(elm, '');
	      }
	    } else if (oldVnode.text !== vnode.text) {
	      api.setTextContent(elm, vnode.text);
	    }
	    if (isDef(hook) && isDef(i = hook.postpatch)) {
	      i(oldVnode, vnode);
	    }
	  }
	
	  return function(oldVnode, vnode) {
	    var i, elm, parent;
	    var insertedVnodeQueue = [];
	    for (i = 0; i < cbs.pre.length; ++i) cbs.pre[i]();
	
	    if (isUndef(oldVnode.sel)) {
	      oldVnode = emptyNodeAt(oldVnode);
	    }
	
	    if (sameVnode(oldVnode, vnode)) {
	      patchVnode(oldVnode, vnode, insertedVnodeQueue);
	    } else {
	      elm = oldVnode.elm;
	      parent = api.parentNode(elm);
	
	      createElm(vnode, insertedVnodeQueue);
	
	      if (parent !== null) {
	        api.insertBefore(parent, vnode.elm, api.nextSibling(elm));
	        removeVnodes(parent, [oldVnode], 0, 0);
	      }
	    }
	
	    for (i = 0; i < insertedVnodeQueue.length; ++i) {
	      insertedVnodeQueue[i].data.hook.insert(insertedVnodeQueue[i]);
	    }
	    for (i = 0; i < cbs.post.length; ++i) cbs.post[i]();
	    return vnode;
	  };
	}
	
	module.exports = {init: init};


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	module.exports = function(sel, data, children, text, elm) {
	  var key = data === undefined ? undefined : data.key;
	  return {sel: sel, data: data, children: children,
	          text: text, elm: elm, key: key};
	};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	module.exports = {
	  array: Array.isArray,
	  primitive: function(s) { return typeof s === 'string' || typeof s === 'number'; },
	};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	function createElement(tagName){
	  return document.createElement(tagName);
	}
	
	function createElementNS(namespaceURI, qualifiedName){
	  return document.createElementNS(namespaceURI, qualifiedName);
	}
	
	function createTextNode(text){
	  return document.createTextNode(text);
	}
	
	
	function insertBefore(parentNode, newNode, referenceNode){
	  parentNode.insertBefore(newNode, referenceNode);
	}
	
	
	function removeChild(node, child){
	  node.removeChild(child);
	}
	
	function appendChild(node, child){
	  node.appendChild(child);
	}
	
	function parentNode(node){
	  return node.parentElement;
	}
	
	function nextSibling(node){
	  return node.nextSibling;
	}
	
	function tagName(node){
	  return node.tagName;
	}
	
	function setTextContent(node, text){
	  node.textContent = text;
	}
	
	module.exports = {
	  createElement: createElement,
	  createElementNS: createElementNS,
	  createTextNode: createTextNode,
	  appendChild: appendChild,
	  removeChild: removeChild,
	  insertBefore: insertBefore,
	  parentNode: parentNode,
	  nextSibling: nextSibling,
	  tagName: tagName,
	  setTextContent: setTextContent
	};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	function updateClass(oldVnode, vnode) {
	  var cur, name, elm = vnode.elm,
	      oldClass = oldVnode.data.class,
	      klass = vnode.data.class;
	
	  if (!oldClass && !klass) return;
	  oldClass = oldClass || {};
	  klass = klass || {};
	
	  for (name in oldClass) {
	    if (!klass[name]) {
	      elm.classList.remove(name);
	    }
	  }
	  for (name in klass) {
	    cur = klass[name];
	    if (cur !== oldClass[name]) {
	      elm.classList[cur ? 'add' : 'remove'](name);
	    }
	  }
	}
	
	module.exports = {create: updateClass, update: updateClass};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	function updateProps(oldVnode, vnode) {
	  var key, cur, old, elm = vnode.elm,
	      oldProps = oldVnode.data.props, props = vnode.data.props;
	
	  if (!oldProps && !props) return;
	  oldProps = oldProps || {};
	  props = props || {};
	
	  for (key in oldProps) {
	    if (!props[key]) {
	      delete elm[key];
	    }
	  }
	  for (key in props) {
	    cur = props[key];
	    old = oldProps[key];
	    if (old !== cur && (key !== 'value' || elm[key] !== cur)) {
	      elm[key] = cur;
	    }
	  }
	}
	
	module.exports = {create: updateProps, update: updateProps};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

	function invokeHandler(handler, vnode, event) {
	  if (typeof handler === "function") {
	    // call function handler
	    handler.call(vnode, event, vnode);
	  } else if (typeof handler === "object") {
	    // call handler with arguments
	    if (typeof handler[0] === "function") {
	      // special case for single argument for performance
	      if (handler.length === 2) {
	        handler[0].call(vnode, handler[1], event, vnode);
	      } else {
	        var args = handler.slice(1);
	        args.push(event);
	        args.push(vnode);
	        handler[0].apply(vnode, args);
	      }
	    } else {
	      // call multiple handlers
	      for (var i = 0; i < handler.length; i++) {
	        invokeHandler(handler[i]);
	      }
	    }
	  }
	}
	
	function handleEvent(event, vnode) {
	  var name = event.type,
	      on = vnode.data.on;
	
	  // call event handler(s) if exists
	  if (on && on[name]) {
	    invokeHandler(on[name], vnode, event);
	  }
	}
	
	function createListener() {
	  return function handler(event) {
	    handleEvent(event, handler.vnode);
	  }
	}
	
	function updateEventListeners(oldVnode, vnode) {
	  var oldOn = oldVnode.data.on,
	      oldListener = oldVnode.listener,
	      oldElm = oldVnode.elm,
	      on = vnode && vnode.data.on,
	      elm = vnode && vnode.elm,
	      name;
	
	  // optimization for reused immutable handlers
	  if (oldOn === on) {
	    return;
	  }
	
	  // remove existing listeners which no longer used
	  if (oldOn && oldListener) {
	    // if element changed or deleted we remove all existing listeners unconditionally
	    if (!on) {
	      for (name in oldOn) {
	        // remove listener if element was changed or existing listeners removed
	        oldElm.removeEventListener(name, oldListener, false);
	      }
	    } else {
	      for (name in oldOn) {
	        // remove listener if existing listener removed
	        if (!on[name]) {
	          oldElm.removeEventListener(name, oldListener, false);
	        }
	      }
	    }
	  }
	
	  // add new listeners which has not already attached
	  if (on) {
	    // reuse existing listener or create new
	    var listener = vnode.listener = oldVnode.listener || createListener();
	    // update vnode for listener
	    listener.vnode = vnode;
	
	    // if element changed or added we add all needed listeners unconditionally
	    if (!oldOn) {
	      for (name in on) {
	        // add listener if element was changed or new listeners added
	        elm.addEventListener(name, listener, false);
	      }
	    } else {
	      for (name in on) {
	        // add listener if new listener added
	        if (!oldOn[name]) {
	          elm.addEventListener(name, listener, false);
	        }
	      }
	    }
	  }
	}
	
	module.exports = {
	  create: updateEventListeners,
	  update: updateEventListeners,
	  destroy: updateEventListeners
	};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(16);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(31);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(33);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(34);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(35);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(32);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(17);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(27);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(18),
	    getPrototype = __webpack_require__(24),
	    isObjectLike = __webpack_require__(26);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(19),
	    getRawTag = __webpack_require__(22),
	    objectToString = __webpack_require__(23);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(20);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(21);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 21 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(19);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 23 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(25);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 25 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 26 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(28);


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(30);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(29)(module)))

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 30 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(16);
	
	var _isPlainObject = __webpack_require__(17);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(32);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(35);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _fetch = __webpack_require__(37);
	
	var _fetch2 = _interopRequireDefault(_fetch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (store) {
	  return function (next) {
	    return function (action) {
	      if (action.type !== 'API_REQ' || !action.payload) return next(action);
	
	      var _action$payload$types = _slicedToArray(action.payload.types, 3),
	          request = _action$payload$types[0],
	          success = _action$payload$types[1],
	          failure = _action$payload$types[2];
	
	      next({
	        type: request,
	        payload: action.payload
	      });
	
	      return callApi(action.payload, store).then(function (response) {
	        return next({
	          type: success,
	          payload: action.payload,
	          response: response
	        });
	      }, function (error) {
	        return next({
	          type: failure,
	          payload: action.payload,
	          error: error
	        });
	      });
	    };
	  };
	};
	
	function callApi(payload, store) {
	  var url = 'https://discgolfmetrix.com/api.php?' + payload.query;
	  var opts = {
	    credentials: 'same-origin',
	    method: payload.verb || (payload.data ? 'POST' : 'GET'),
	    headers: {
	      'Accept': 'application/json'
	    }
	  };
	
	  if (payload.data) {
	    _extends(opts.headers, {
	      'Content-Type': 'application/x-www-form-urlencoded'
	    });
	    opts.body = payload.data;
	  }
	
	  return (0, _fetch2.default)(url, opts).then(parseResponse);
	}
	
	function parseResponse(response) {
	  return response.ok ? response.json() : response.json().then(function (e) {
	    return throwResponseError(response, e);
	  }, function () {
	    return throwResponseError(response);
	  });
	}
	
	function throwResponseError(response, errJson) {
	  throw _extends({
	    status: response.status,
	    statusText: response.statusText,
	    message: response.statusText
	  }, errJson);
	}

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = fetch;
	/**
	 * Disguising XMLHttpRequest as fetch to
	 * leverage the progress event hook
	 */
	function fetch(url, options) {
	  return new Promise(function (fulfill) {
	    options = _extends({
	      method: 'GET',
	      headers: {}
	    }, options);
	
	    var xhr = new XMLHttpRequest();
	    var done = function done() {
	      return fulfill({
	        ok: 200 <= xhr.status && xhr.status < 300,
	        status: xhr.status,
	        statusText: xhr.statusText,
	        json: function json() {
	          return new Promise(function (fulfill, reject) {
	            try {
	              var json = JSON.parse(xhr.responseText.trim());
	              fulfill(json);
	            } catch (err) {
	              reject(err);
	            }
	          });
	        }
	      });
	    };
	
	    xhr.open(options.method, url);
	    // xhr.withCredentials = true
	
	    Object.keys(options.headers).forEach(function (header) {
	      return xhr.setRequestHeader(header, options.headers[header]);
	    });
	
	    xhr.addEventListener('error', done);
	    xhr.addEventListener('abort', done);
	    xhr.upload.addEventListener('error', done);
	    xhr.upload.addEventListener('abort', done);
	
	    xhr.addEventListener('readystatechange', function () {
	      if (xhr.readyState === XMLHttpRequest.DONE) done();
	    });
	
	    if (typeof options.onUploadProgress === 'function') xhr.upload.addEventListener('progress', options.onUploadProgress);
	
	    xhr.send(options.body);
	  });
	}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp, _initialiseProps;
	
	__webpack_require__(5);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SelectCompetition = (_temp = _class = function () {
	  function SelectCompetition(el, onChange) {
	    var _this = this;
	
	    _classCallCheck(this, SelectCompetition);
	
	    _initialiseProps.call(this);
	
	    this.el = el;
	    this.onChange = onChange;
	    this.overlay = this.getOverlay();
	    this.options = el.querySelector('.options');
	    this.competitions = this.options.querySelectorAll('.competition');
	    this.selectedOption = el.querySelector('.selected option');
	
	    el.querySelector('.selected').addEventListener('click', function (evt) {
	      return _this.open();
	    });
	    document.addEventListener('mousedown', function (evt) {
	      return _this.onDocumentClick(evt);
	    });
	    document.addEventListener('touchend', function (evt) {
	      return _this.onDocumentClick(evt);
	    });
	
	    this.activeCompetitionIdx = 0;
	    for (var i = 0; i < this.competitions.length; i++) {
	      this.competitions[i].addEventListener('click', this.onSelect);
	      if (this.competitions[i].classList.contains('active')) this.activeCompetitionIdx = i;
	    }
	
	    var buttons = el.querySelectorAll('.competition-nav-button');
	    this.prevBtn = buttons[0];
	    this.nextBtn = buttons[1];
	    this.setButtonStates();
	    this.prevBtn.addEventListener('click', function () {
	      clearTimeout(_this.btnThrottle);
	      _this.btnThrottle = setTimeout(_this.onClickPrev, 400);
	    });
	    this.nextBtn.addEventListener('click', function () {
	      clearTimeout(_this.btnThrottle);
	      _this.btnThrottle = setTimeout(_this.onClickNext, 400);
	    });
	  }
	
	  _createClass(SelectCompetition, [{
	    key: 'getOverlay',
	    value: function getOverlay() {
	      var overlay = document.querySelector('.discgolfmetrix-select-competitions-overlay');
	
	      if (!overlay) {
	        overlay = document.createElement('div');
	        overlay.setAttribute('class', 'discgolfmetrix-select-competitions-overlay');
	        document.body.insertBefore(overlay, null);
	      }
	
	      return overlay;
	    }
	  }, {
	    key: 'setButtonStates',
	    value: function setButtonStates() {
	      this.activeCompetitionIdx == 0 ? this.prevBtn.classList.add('disabled') : this.prevBtn.classList.remove('disabled');
	      this.activeCompetitionIdx == this.competitions.length - 1 ? this.nextBtn.classList.add('disabled') : this.nextBtn.classList.remove('disabled');
	    }
	  }]);
	
	  return SelectCompetition;
	}(), _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.onDocumentClick = function (evt) {
	    var node = evt.target;
	
	    while (node !== null) {
	      if (_this2.options === node || _this2.selected === node) return;
	
	      node = node.parentNode;
	    }
	
	    _this2.close();
	  };
	
	  this.onSelect = function (evt) {
	    _this2.close();
	    _this2.selectCompetition(evt.target);
	  };
	
	  this.selectCompetition = function (el) {
	    _this2.selectedOption.textContent = el.innerHTML;
	
	    for (var i = 0; i < _this2.competitions.length; i++) {
	      if (_this2.competitions[i] === el) {
	        _this2.activeCompetitionIdx = i;
	        _this2.competitions[i].classList.add('active');
	      } else _this2.competitions[i].classList.remove('active');
	    }_this2.setButtonStates();
	
	    if (typeof _this2.onChange === 'function') _this2.onChange(el.dataset.id);
	  };
	
	  this.open = function () {
	    if (_this2.isVisible(_this2.options)) return _this2.close();
	
	    _this2.options.style.display = 'block';
	    _this2.position(true);
	    optimizedResize.add(_this2.position);
	  };
	
	  this.close = function () {
	    _this2.options.style.display = 'none';
	    _this2.overlay.style.display = 'none';
	    optimizedResize.remove(_this2.position);
	  };
	
	  this.position = function () {
	    var opening = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    if (window.innerWidth <= 640) {
	      _this2.overlay.style.display = 'block';
	      _this2.options.style.position = 'fixed';
	      _this2.options.style.left = 'auto';
	      _this2.options.style.top = 'auto';
	      _this2.options.style.left = (Math.ceil(window.innerWidth) - _this2.options.offsetWidth) / 2 + 'px';
	      _this2.options.style.top = (Math.ceil(window.innerHeight) - _this2.options.offsetHeight) / 2 + 'px';
	    } else {
	      _this2.overlay.style.display = 'none';
	      _this2.options.style.position = 'absolute';
	      _this2.options.style.left = '';
	      _this2.options.style.top = '';
	    }
	    _this2.prevWinWidth = window.innerWidth;
	  };
	
	  this.isVisible = function (el) {
	    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
	  };
	
	  this.onClickPrev = function () {
	    _this2.selectCompetition(_this2.competitions[_this2.activeCompetitionIdx - 1]);
	  };
	
	  this.onClickNext = function () {
	    _this2.selectCompetition(_this2.competitions[_this2.activeCompetitionIdx + 1]);
	  };
	}, _temp);
	exports.default = SelectCompetition;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /** @jsx html */
	
	
	var _snabbdomJsx = __webpack_require__(6);
	
	var _snabbdom = __webpack_require__(7);
	
	var _util = __webpack_require__(40);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SelectPlayers = function () {
	  function SelectPlayers(_ref, state, store) {
	    var container = _ref.container,
	        select = _ref.select;
	
	    var _this = this;
	
	    _classCallCheck(this, SelectPlayers);
	
	    this.onChange = function (evt) {
	      _this.dispatchAction((0, _util.getMultiSelectValue)(evt.target));
	    };
	
	    this.onBlur = function () {
	      if (_this.isAllSelected()) _this.dispatchAction(['all']);
	
	      _this.close();
	    };
	
	    this.isAllSelected = function () {
	      var selected = _this.state.filters.players.selected;
	
	
	      return !Array.isArray(selected) || !selected.length || selected.indexOf('all') > -1;
	    };
	
	    this.onDocumentClick = function (evt) {
	      var node = evt.target;
	
	      while (node !== null) {
	        if (_this.container.elm === node) return;
	
	        node = node.parentNode;
	      }
	
	      _this.close();
	    };
	
	    this.container = container;
	    this.select = select;
	    this.store = store;
	    document.addEventListener('mousedown', function (evt) {
	      return _this.onDocumentClick(evt);
	    });
	    document.addEventListener('touchend', function (evt) {
	      return _this.onDocumentClick(evt);
	    });
	    document.addEventListener('touchstart', function (evt) {
	      return _this.setState({ touch: true });
	    });
	    this.setState(state);
	  }
	
	  _createClass(SelectPlayers, [{
	    key: 'setState',
	    value: function setState(state) {
	      this.state = _extends({}, this.state, state);
	      this.render();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state$filters$player = this.state.filters.players,
	          selected = _state$filters$player.selected,
	          lastChanged = _state$filters$player.lastChanged;
	
	      var isAllSelected = this.isAllSelected();
	      var options = ((0, _util.getDeepProp)(this.state, 'data.filters.players') || []).slice(0);
	
	      // sort alphabetically
	      options.sort(function (a, b) {
	        return a.Name.toLowerCase() > b.Name.toLowerCase() ? 1 : a.Name.toLowerCase() < b.Name.toLowerCase() ? -1 : 0;
	      });
	
	      var open = this.open.bind(this);
	      var container = (0, _snabbdomJsx.html)(
	        'div',
	        {
	          key: 'container',
	          'class': {
	            'discgolfmetrix-results-filter-control-select-players': 1,
	            'no-options': !options.length,
	            touch: this.state.touch
	          },
	          'on-click': open,
	          'on-touchstart': open
	        },
	        (0, _snabbdomJsx.html)(
	          'select',
	          { 'class': { placeholder: 1, visible: !this.state.showMultiselect } },
	          (0, _snabbdomJsx.html)(
	            'option',
	            null,
	            isAllSelected ? window.discgolfmetrixResults.l10n.all.players : selected.length === 1 ? selected[0] : window.discgolfmetrixResults.l10n.multiple.players
	          )
	        ),
	        (0, _snabbdomJsx.html)(
	          'select',
	          {
	            key: 'select-players',
	            name: 'players',
	            multiple: true,
	            autoComplete: 'off',
	            'on-change': this.onChange,
	            'on-blur': this.onBlur,
	            'class': { visible: this.state.showMultiselect }
	          },
	          (0, _snabbdomJsx.html)(
	            'option',
	            { key: 'all', value: 'all', selected: isAllSelected },
	            window.discgolfmetrixResults.l10n.all.players
	          ),
	          options.map(function (_ref2) {
	            var Name = _ref2.Name;
	            return (0, _snabbdomJsx.html)(
	              'option',
	              {
	                key: Name + '-' + (lastChanged || Date.now()),
	                value: Name,
	                selected: selected.indexOf(Name) > -1
	              },
	              Name
	            );
	          })
	        )
	      );
	
	      /* clear SSR element before patching in a vnode */
	      if (this.container instanceof Element) this.container.innerHTML = '';
	
	      this.container = (0, _snabbdom.patch)(this.container, container);
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      if (!this.state.showMultiselect) {
	        var newState = {
	          showMultiselect: true,
	          hasOpened: true
	        };
	
	        if (!this.state.hasOpened) newState.filters = _extends({}, this.state.filters, {
	          players: _extends({}, this.state.filters.players, {
	            lastChanged: Date.now()
	          })
	        });
	
	        this.setState(newState);
	
	        // IE workaround
	        document.querySelector('.discgolfmetrix-results-filter select.placeholder').blur();
	      }
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      if (this.state.showMultiselect) this.setState({ showMultiselect: false });
	    }
	  }, {
	    key: 'dispatchAction',
	    value: function dispatchAction(selected) {
	      this.store.dispatch({
	        type: 'FILTER',
	        payload: {
	          players: {
	            selected: selected,
	            lastChanged: Date.now() // to force-patch vNode
	          }
	        }
	      });
	    }
	  }]);
	
	  return SelectPlayers;
	}();
	
	exports.default = SelectPlayers;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; // to support array spread op in getMultiSelectValue() below in IE11
	
	
	exports.getDeepProp = getDeepProp;
	exports.setDeepProp = setDeepProp;
	exports.arraySum = arraySum;
	exports.deepCopy = deepCopy;
	exports.getMultiSelectValue = getMultiSelectValue;
	exports.getIOSVer = getIOSVer;
	
	__webpack_require__(41);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function getDeepProp(obj, path) {
	  var delim = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
	
	  var arr = path instanceof Array ? path : path.split(delim);
	
	  return arr.reduce(function (obj, prop) {
	    return obj ? obj[prop] : obj;
	  }, obj);
	}
	
	function setDeepProp(obj, path, value) {
	  var delim = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
	
	  if (typeof value !== 'undefined' && path.length) {
	    var arr = path instanceof Array ? path : path.split(delim);
	
	    if (arr.length > 1) {
	      if (typeof obj[arr[0]] === 'undefined') obj[arr[0]] = typeof arr[1] === 'number' ? [] : {};
	
	      setDeepProp(obj[arr[0]], arr.slice(1), value);
	    } else obj[arr[0]] = value;
	  }
	
	  return obj;
	}
	
	function arraySum(arr) {
	  return arr.reduce(function (sum, val) {
	    var num = parseFloat(val);
	    return isNaN(num) ? sum : sum + num;
	  }, 0);
	}
	
	/**
	 * Basic deep object cloner
	 */
	function deepCopy(obj) {
	  var copy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  for (var i in obj) {
	    copy[i] = _typeof(obj[i]) == "object" && obj[i] !== null ? deepCopy(obj[i], obj[i].constructor()) : obj[i];
	  }return copy;
	}
	
	/**
	 * Returns an array of selected option values.
	 */
	function getMultiSelectValue(el) {
	  return (el.selectedOptions ? [].concat(_toConsumableArray(el.selectedOptions)) : [].concat(_toConsumableArray(el.options)).filter(function (o) {
	    return o.selected;
	  })).map(function (o) {
	    return o.value;
	  });
	}
	
	/**
	 * https://gist.github.com/Craga89/2829457
	 */
	function getIOSVer() {
	  return parseFloat(('' + (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [0, ''])[1]).replace('undefined', '3_2').replace('_', '.').replace('_', '')) || false;
	}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(42);
	__webpack_require__(86);
	module.exports = __webpack_require__(50).Array.from;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(43)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(46)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(44);
	var defined = __webpack_require__(45);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 44 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 45 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(47);
	var $export = __webpack_require__(48);
	var redefine = __webpack_require__(61);
	var hide = __webpack_require__(51);
	var has = __webpack_require__(62);
	var Iterators = __webpack_require__(66);
	var $iterCreate = __webpack_require__(67);
	var setToStringTag = __webpack_require__(82);
	var getPrototypeOf = __webpack_require__(84);
	var ITERATOR = __webpack_require__(83)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(49);
	var core = __webpack_require__(50);
	var hide = __webpack_require__(51);
	var redefine = __webpack_require__(61);
	var ctx = __webpack_require__(64);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 49 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 50 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.1' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(52);
	var createDesc = __webpack_require__(60);
	module.exports = __webpack_require__(56) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(53);
	var IE8_DOM_DEFINE = __webpack_require__(55);
	var toPrimitive = __webpack_require__(59);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(56) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(54);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(56) && !__webpack_require__(57)(function () {
	  return Object.defineProperty(__webpack_require__(58)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(57)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 57 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(54);
	var document = __webpack_require__(49).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(54);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 60 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(49);
	var hide = __webpack_require__(51);
	var has = __webpack_require__(62);
	var SRC = __webpack_require__(63)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(50).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 62 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(65);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 65 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 66 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(68);
	var descriptor = __webpack_require__(60);
	var setToStringTag = __webpack_require__(82);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(51)(IteratorPrototype, __webpack_require__(83)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(53);
	var dPs = __webpack_require__(69);
	var enumBugKeys = __webpack_require__(80);
	var IE_PROTO = __webpack_require__(78)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(58)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(81).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(52);
	var anObject = __webpack_require__(53);
	var getKeys = __webpack_require__(70);
	
	module.exports = __webpack_require__(56) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(71);
	var enumBugKeys = __webpack_require__(80);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(62);
	var toIObject = __webpack_require__(72);
	var arrayIndexOf = __webpack_require__(75)(false);
	var IE_PROTO = __webpack_require__(78)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(73);
	var defined = __webpack_require__(45);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(74);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 74 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(72);
	var toLength = __webpack_require__(76);
	var toAbsoluteIndex = __webpack_require__(77);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(44);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(44);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(79)('keys');
	var uid = __webpack_require__(63);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(49);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ }),
/* 80 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(49).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(52).f;
	var has = __webpack_require__(62);
	var TAG = __webpack_require__(83)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(79)('wks');
	var uid = __webpack_require__(63);
	var Symbol = __webpack_require__(49).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(62);
	var toObject = __webpack_require__(85);
	var IE_PROTO = __webpack_require__(78)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(45);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(64);
	var $export = __webpack_require__(48);
	var toObject = __webpack_require__(85);
	var call = __webpack_require__(87);
	var isArrayIter = __webpack_require__(88);
	var toLength = __webpack_require__(76);
	var createProperty = __webpack_require__(89);
	var getIterFn = __webpack_require__(90);
	
	$export($export.S + $export.F * !__webpack_require__(92)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(53);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(66);
	var ITERATOR = __webpack_require__(83)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(52);
	var createDesc = __webpack_require__(60);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(91);
	var ITERATOR = __webpack_require__(83)('iterator');
	var Iterators = __webpack_require__(66);
	module.exports = __webpack_require__(50).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(74);
	var TAG = __webpack_require__(83)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(83)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /** @jsx html */
	
	
	__webpack_require__(94);
	
	__webpack_require__(98);
	
	__webpack_require__(112);
	
	var _snabbdomJsx = __webpack_require__(6);
	
	var _h = __webpack_require__(129);
	
	var _h2 = _interopRequireDefault(_h);
	
	var _snabbdom = __webpack_require__(7);
	
	var _util = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var profileIcon = '<svg width="100%" height="100%" viewBox="0 0 512 512" preserveAspectRatio="xMidYMid meet"><path d="' + window.discgolfmetrixResults.profile_link_icon_path + '"/></svg>';
	var noClassFlag = '$___NO_CLASS';
	var extras = {
	  BUE: { type: Boolean, totalFmt: 'percent' },
	  GRH: { type: Boolean, totalFmt: 'percent' },
	  OCP: { type: Boolean, totalFmt: 'sum' },
	  ICP: { type: Number, totalFmt: 'percent' },
	  IBP: { type: Boolean, totalFmt: 'sum' },
	  PEN: { type: Number, totalFmt: 'sum' }
	};
	var addPlus = function addPlus(value) {
	  return (parseFloat(value) > 0 ? '+' : '') + value;
	};
	
	var ResultsTable = function () {
	  function ResultsTable(el, state, onChange) {
	    _classCallCheck(this, ResultsTable);
	
	    this.toggleResultsExtra = function (showExtras, evt) {
	      evt.preventDefault();
	
	      if (!showExtras) return;
	
	      var tr = evt.target;
	
	      while (tr.tagName !== 'TR') {
	        tr = tr.parentNode;
	      }if (tr.classList.contains('expanded')) {
	        tr.parentNode.classList.remove('expanded');
	        tr.classList.remove('expanded');
	      } else {
	        tr.parentNode.classList.add('expanded');
	        tr.classList.add('expanded');
	      }
	    };
	
	    this.el = el;
	    this.onChange = onChange;
	    this.competitionID = null;
	    this.iOSVer = (0, _util.getIOSVer)();
	    this.setState(state);
	  }
	
	  _createClass(ResultsTable, [{
	    key: 'setState',
	    value: function setState(state) {
	      this.state = state;
	      this.render();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _getDeepProp = (0, _util.getDeepProp)(this.state, 'data.results'),
	          Competition = _getDeepProp.Competition;
	
	      var table = !!Competition.ShowTourView ? this.getTourSummaryTable(Competition) : this.getCompetitionResultsTable(Competition);
	
	      // clear SSR table before patching in a vnode
	      if (this.el instanceof Element) this.el.innerHTML = '';
	
	      this.el = (0, _snabbdom.patch)(this.el, table);
	    }
	  }, {
	    key: 'getCompetitionResultsTable',
	    value: function getCompetitionResultsTable(Competition) {
	      var _this = this;
	
	      var hasSubcompetitions = !!(Competition.SubCompetitions || []).length;
	      var showExtras = !hasSubcompetitions && Competition.hasOwnProperty('MetrixMode') && Competition.MetrixMode == 2;
	      var showPreviousRoundsSum = Competition.hasOwnProperty('ShowPreviousRoundsSum') && !!parseInt(Competition.ShowPreviousRoundsSum, 10);
	      if (this.competitionID != Competition.ID) {
	        this.playersByClasses = this.getPlayersByClasses(this.aggregateResults());
	        this.orderPlayersByTotalScore();
	        this.rankPlayers();
	        this.competitionID = Competition.ID;
	      }
	      var parTotal = 0,
	          colSpan = hasSubcompetitions ? 3 : 2;
	      var playersByClasses = this.filterPlayers();
	
	      return (0, _snabbdomJsx.html)(
	        'div',
	        { className: 'discgolfmetrix-results-table ' + (this.iOSVer ? 'ios' : ''), 'class': { loading: this.state.loading } },
	        (0, _snabbdomJsx.html)(
	          'div',
	          { className: 'discgolfmetrix-results-table-container table-scroll table-responsive' },
	          (0, _snabbdomJsx.html)(
	            'table',
	            { key: Competition.ID },
	            (0, _snabbdomJsx.html)(
	              'colgroup',
	              null,
	              (0, _snabbdomJsx.html)('col', { width: '1%' }),
	              (0, _snabbdomJsx.html)('col', { width: '100%' })
	            ),
	            (0, _snabbdomJsx.html)(
	              'thead',
	              null,
	              (0, _snabbdomJsx.html)(
	                'tr',
	                { className: 'hole' },
	                (0, _snabbdomJsx.html)('th', { className: 'hole', colSpan: colSpan }),
	                this.state.data.results.Competition.Tracks.map(function (_ref, idx) {
	                  var Number = _ref.Number;
	                  return (0, _snabbdomJsx.html)(
	                    'th',
	                    null,
	                    Number
	                  );
	                }),
	                (0, _snabbdomJsx.html)(
	                  'th',
	                  null,
	                  window.discgolfmetrixResults.l10n.sum
	                ),
	                (0, _snabbdomJsx.html)(
	                  'th',
	                  null,
	                  window.discgolfmetrixResults.l10n.to_par
	                ),
	                hasSubcompetitions || showPreviousRoundsSum ? [(0, _snabbdomJsx.html)('th', null), (0, _snabbdomJsx.html)('th', null)] : ''
	              ),
	              (0, _snabbdomJsx.html)(
	                'tr',
	                { className: 'par' },
	                (0, _snabbdomJsx.html)(
	                  'th',
	                  { className: 'par', colSpan: colSpan },
	                  window.discgolfmetrixResults.l10n.par
	                ),
	                this.state.data.results.Competition.Tracks.map(function (_ref2, idx) {
	                  var Par = _ref2.Par;
	
	                  parTotal += parseInt(Par, 10);
	                  return (0, _snabbdomJsx.html)(
	                    'th',
	                    null,
	                    Par
	                  );
	                }),
	                (0, _snabbdomJsx.html)(
	                  'th',
	                  null,
	                  parTotal
	                ),
	                (0, _snabbdomJsx.html)('th', null),
	                hasSubcompetitions || showPreviousRoundsSum ? [(0, _snabbdomJsx.html)('th', null), (0, _snabbdomJsx.html)('th', null)] : ''
	              )
	            ),
	            playersByClasses.order.map(function (className) {
	              return [className == noClassFlag || !playersByClasses.byName[className].order.length ? '' : (0, _snabbdomJsx.html)(
	                'thead',
	                { key: Competition.ID + '/' + className },
	                (0, _snabbdomJsx.html)(
	                  'tr',
	                  { className: 'class' },
	                  (0, _snabbdomJsx.html)(
	                    'th',
	                    { className: 'class', colSpan: Competition.Tracks.length + (hasSubcompetitions ? 7 : showPreviousRoundsSum ? 6 : 4) },
	                    className + ' (' + _this.playersByClasses.byName[className].order.length + ')'
	                  )
	                )
	              ), playersByClasses.byName[className].order.map(function (playerName, idx) {
	                var player = playersByClasses.byName[className].byName[playerName];
	                var competitionKeys = Object.keys(player.PlayerResults);
	                var rowSpan = hasSubcompetitions && showExtras ? competitionKeys.length + competitionKeys.length * Object.keys(extras).length : competitionKeys.length;
	                var totalSum = (0, _util.arraySum)(Object.values(player.Sum));
	                var totalDiff = (0, _util.arraySum)(Object.values(player.Diff));
	                var key = Competition.ID + '/' + (player.UserID || player.Name);
	
	                return (0, _snabbdomJsx.html)(
	                  'tbody',
	                  { key: key },
	                  competitionKeys.map(function (competitionKey, idx) {
	                    var scoresRow = (0, _snabbdomJsx.html)(
	                      'tr',
	                      { key: key + '/' + competitionKey, 'on-click': _this.toggleResultsExtra.bind(_this, showExtras) },
	                      idx !== 0 ? '' : [(0, _snabbdomJsx.html)(
	                        'td',
	                        { key: [key, competitionKey, 'standing'].join('/'), className: 'standing', rowSpan: rowSpan },
	                        player.standing
	                      ), (0, _snabbdomJsx.html)(
	                        'td',
	                        { key: [key, competitionKey, 'player'].join('/'), className: 'player', rowSpan: rowSpan, title: player.Name },
	                        (0, _snabbdomJsx.html)(
	                          'div',
	                          null,
	                          showExtras ? (0, _snabbdomJsx.html)(
	                            'a',
	                            { className: 'expand-metrix', 'on-click': function onClick(evt) {
	                                return evt.preventDefault();
	                              }, href: '#' },
	                            (0, _snabbdomJsx.html)('i', null),
	                            ' ',
	                            player.Name
	                          ) : player.Name,
	                          !player.hasOwnProperty('UserID') ? '' : (0, _snabbdomJsx.html)(
	                            'a',
	                            {
	                              className: 'profile-link',
	                              target: '_blank',
	                              href: 'https://discgolfmetrix.com/?u=player_stat&player_user_id=' + player.UserID,
	                              'on-click': function onClick(evt) {
	                                return evt.stopPropagation();
	                              } },
	                            (0, _h2.default)('span', { props: { innerHTML: profileIcon } })
	                          )
	                        )
	                      )],
	                      !hasSubcompetitions ? '' : _this.getSubcompetitionCell(competitionKey),
	                      player.PlayerResults[competitionKey].map(function (score, idx) {
	                        return _this.getScoreCell(player, competitionKey, score, idx);
	                      }),
	                      (0, _snabbdomJsx.html)(
	                        'td',
	                        { className: 'sum' },
	                        player.Sum[competitionKey]
	                      ),
	                      (0, _snabbdomJsx.html)(
	                        'td',
	                        { className: 'diff' },
	                        addPlus(player.Diff[competitionKey])
	                      ),
	                      hasSubcompetitions && idx === 0 ? [(0, _snabbdomJsx.html)(
	                        'td',
	                        { key: [key, competitionKey, 'sum'].join('/'), className: 'sum', rowSpan: rowSpan },
	                        totalSum
	                      ), (0, _snabbdomJsx.html)(
	                        'td',
	                        { key: [key, competitionKey, 'diff'].join('/'), className: 'diff', rowSpan: rowSpan },
	                        addPlus(totalDiff)
	                      )] : !showPreviousRoundsSum ? '' : [(0, _snabbdomJsx.html)(
	                        'td',
	                        { key: [key, competitionKey, 'sum'].join('/'), className: 'sum', rowSpan: rowSpan },
	                        player.PreviousRoundsSum
	                      ), (0, _snabbdomJsx.html)(
	                        'td',
	                        { key: [key, competitionKey, 'diff'].join('/'), className: 'diff', rowSpan: rowSpan },
	                        addPlus(player.PreviousRoundsDiff)
	                      )]
	                    );
	
	                    return showExtras ? [scoresRow].concat(_this.getExtraRows(player, competitionKey, hasSubcompetitions, showPreviousRoundsSum)) : scoresRow;
	                  })
	                );
	              })];
	            })
	          )
	        ),
	        (0, _snabbdomJsx.html)(
	          'span',
	          { className: 'spinner' },
	          (0, _snabbdomJsx.html)('i', null),
	          (0, _snabbdomJsx.html)('i', null)
	        )
	      );
	    }
	  }, {
	    key: 'getTourSummaryTable',
	    value: function getTourSummaryTable(Competition) {
	      var _this2 = this;
	
	      if (this.competitionID != Competition.ID) {
	        this.playersByClasses = this.getPlayersByClasses(this.aggregateResults());
	        this.competitionID = Competition.ID;
	      }
	      var playersByClasses = this.filterPlayers();
	
	      return (0, _snabbdomJsx.html)(
	        'div',
	        { className: 'discgolfmetrix-results-table ' + (this.iOSVer ? 'ios' : ''), 'class': { loading: this.state.loading } },
	        (0, _snabbdomJsx.html)(
	          'div',
	          { className: 'discgolfmetrix-results-table-container table-scroll table-responsive' },
	          (0, _snabbdomJsx.html)(
	            'table',
	            { key: Competition.ID },
	            (0, _snabbdomJsx.html)(
	              'colgroup',
	              null,
	              (0, _snabbdomJsx.html)('col', { width: '1%' }),
	              (0, _snabbdomJsx.html)('col', { width: '100%' })
	            ),
	            (0, _snabbdomJsx.html)(
	              'thead',
	              null,
	              (0, _snabbdomJsx.html)(
	                'tr',
	                { className: 'tour-head' },
	                (0, _snabbdomJsx.html)('th', null),
	                (0, _snabbdomJsx.html)('th', null),
	                Competition.Events.map(function (event) {
	                  return (0, _snabbdomJsx.html)(
	                    'th',
	                    null,
	                    (0, _snabbdomJsx.html)(
	                      'a',
	                      {
	                        target: '_blank',
	                        href: 'https://discgolfmetrix.com/?u=player_stat&player_user_id=' + event.ID,
	                        'on-click': function onClick(evt) {
	                          evt.preventDefault();
	                          if (typeof _this2.onChange === 'function') _this2.onChange(event.ID, true);
	                        }
	                      },
	                      event.Name
	                    )
	                  );
	                }),
	                (0, _snabbdomJsx.html)(
	                  'th',
	                  null,
	                  window.discgolfmetrixResults.l10n.total
	                )
	              )
	            ),
	            playersByClasses.order.map(function (className) {
	              return [className == noClassFlag || !playersByClasses.byName[className].order.length ? '' : (0, _snabbdomJsx.html)(
	                'thead',
	                { key: Competition.ID + '/' + className },
	                (0, _snabbdomJsx.html)(
	                  'tr',
	                  { className: 'class' },
	                  (0, _snabbdomJsx.html)(
	                    'th',
	                    { className: 'class', colSpan: Competition.Events.length + 3 },
	                    className + ' (' + _this2.playersByClasses.byName[className].order.length + ')'
	                  )
	                )
	              ), playersByClasses.byName[className].order.map(function (playerName, idx) {
	                var player = playersByClasses.byName[className].byName[playerName];
	                var key = Competition.ID + '/' + (player.UserID || player.Name);
	
	                return (0, _snabbdomJsx.html)(
	                  'tbody',
	                  { key: key },
	                  (0, _snabbdomJsx.html)(
	                    'tr',
	                    null,
	                    (0, _snabbdomJsx.html)(
	                      'td',
	                      { className: 'standing' },
	                      player.Place
	                    ),
	                    (0, _snabbdomJsx.html)(
	                      'td',
	                      { className: 'player' },
	                      !player.hasOwnProperty('UserID') ? player.Name : (0, _snabbdomJsx.html)(
	                        'a',
	                        {
	                          target: '_blank',
	                          href: 'https://discgolfmetrix.com/?u=player_stat&player_user_id=' + player.UserID
	                        },
	                        player.Name
	                      )
	                    ),
	                    Competition.Events.map(function (event, idx) {
	                      return (0, _snabbdomJsx.html)(
	                        'td',
	                        null,
	                        typeof player.EventResults[idx] === 'number' || typeof player.EventResults[idx] === 'string' ? player.EventResults[idx] : ''
	                      );
	                    }),
	                    (0, _snabbdomJsx.html)(
	                      'td',
	                      { className: 'total' },
	                      player.Total
	                    )
	                  )
	                );
	              })];
	            })
	          )
	        ),
	        (0, _snabbdomJsx.html)(
	          'span',
	          { className: 'spinner' },
	          (0, _snabbdomJsx.html)('i', null),
	          (0, _snabbdomJsx.html)('i', null)
	        )
	      );
	    }
	    /**
	     * Aggregates results and subcompetition results
	     */
	
	  }, {
	    key: 'aggregateResults',
	    value: function aggregateResults() {
	      var players = { byName: {}, order: [] };
	      var add = function add(competition) {
	        var isTour = !!Competition.ShowTourView;
	        var competitionKey = competition.Date + 'T' + competition.Time;
	        var results = isTour ? competition.TourResults : competition.Results;(results || []).forEach(function (player) {
	          if (!players.byName.hasOwnProperty(player.Name)) {
	            players.byName[player.Name] = _extends({}, player);
	            if (!isTour) {
	              players.byName[player.Name].Sum = {};
	              players.byName[player.Name].Diff = {};
	              players.byName[player.Name].PlayerResults = _defineProperty({}, competitionKey, []);
	            }
	            players.order.push(player.Name);
	          }
	          if (!isTour) {
	            players.byName[player.Name].Sum[competitionKey] = player.Sum;
	            players.byName[player.Name].Diff[competitionKey] = player.Diff;
	            players.byName[player.Name].PlayerResults[competitionKey] = [];(player.PlayerResults || []).forEach(function (score) {
	              return players.byName[player.Name].PlayerResults[competitionKey].push(score);
	            });
	          }
	        });
	
	        if (competition.SubCompetitions) if ((competition.SubCompetitions || []).length) competition.SubCompetitions.forEach(add);
	      };
	
	      var _getDeepProp2 = (0, _util.getDeepProp)(this.state, 'data.results'),
	          Competition = _getDeepProp2.Competition;
	
	      if (Competition) add(Competition);
	
	      return players;
	    }
	  }, {
	    key: 'getPlayersByClasses',
	    value: function getPlayersByClasses(players) {
	      return players.order.reduce(function (classes, playerName) {
	        var className = players.byName[playerName].ClassName || noClassFlag;
	
	        if (!classes.byName.hasOwnProperty(className)) {
	          classes.byName[className] = { byName: {}, order: [] };
	          classes.order.push(className);
	        }
	
	        classes.byName[className].byName[playerName] = players.byName[playerName];
	        classes.byName[className].order.push(playerName);
	
	        return classes;
	      }, {
	        byName: {}, order: []
	      });
	    }
	    /**
	     * Orders players by total score. Mutates this.playersByClasses.
	     */
	
	  }, {
	    key: 'orderPlayersByTotalScore',
	    value: function orderPlayersByTotalScore() {
	      var _this3 = this;
	
	      var _getDeepProp3 = (0, _util.getDeepProp)(this.state, 'data.results'),
	          Competition = _getDeepProp3.Competition;
	
	      if (!Competition || !this.playersByClasses) return;
	
	      var numCompetitions = (Array.isArray(Competition.SubCompetitions) ? Competition.SubCompetitions.length : 0) + (Array.isArray(Competition.Results) && Competition.Results.length ? 1 : 0);
	      var missingCompetitions = function missingCompetitions(player) {
	        return {}.toString.call(player.PlayerResults) != '[object Object]' || Object.keys(player.PlayerResults).length < numCompetitions;
	      };
	      var missingResults = function missingResults(player) {
	        for (var competitionKey in player.PlayerResults) {
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = player.PlayerResults[competitionKey][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var score = _step.value;
	
	              if ({}.toString.call(score) != '[object Object]' || !score.hasOwnProperty('Result')) return true;
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	        }return false;
	      };
	      var prop = Competition.hasOwnProperty('ShowPreviousRoundsSum') && !!parseInt(Competition.ShowPreviousRoundsSum, 10) ? 'PreviousRoundsDiff' : 'Diff';
	      var getTotal = function getTotal(diff) {
	        return {}.toString.call(diff) == '[object Object]' ? (0, _util.arraySum)(Object.values(diff)) : diff;
	      };
	
	      this.playersByClasses.order.forEach(function (className) {
	        var players = _this3.playersByClasses.byName[className];
	        players.order.sort(function (a, b) {
	          var playerA = players.byName[a];
	          var playerB = players.byName[b];
	
	          if (!missingResults(playerA) && missingResults(playerB)) return -1;
	          if (missingResults(playerA) && !missingResults(playerB)) return 1;
	          if (!missingCompetitions(playerA) && missingCompetitions(playerB)) return -1;
	          if (missingCompetitions(playerA) && !missingCompetitions(playerB)) return 1;
	
	          if (getTotal(playerA[prop]) < getTotal(playerB[prop])) return -1;
	          if (getTotal(playerA[prop]) > getTotal(playerB[prop])) return 1;
	
	          if (players.order.indexOf(a) < players.order.indexOf(b)) return -1;
	          if (players.order.indexOf(a) > players.order.indexOf(b)) return 1;
	
	          return 0;
	        });
	      });
	    }
	    /**
	     * Ranks players (sets “standing” property). Mutates this.playersByClasses.
	     */
	
	  }, {
	    key: 'rankPlayers',
	    value: function rankPlayers() {
	      var _this4 = this;
	
	      var _getDeepProp4 = (0, _util.getDeepProp)(this.state, 'data.results'),
	          Competition = _getDeepProp4.Competition;
	
	      if (!Competition || !this.playersByClasses) return;
	
	      var prop = Competition.hasOwnProperty('ShowPreviousRoundsSum') && !!parseInt(Competition.ShowPreviousRoundsSum, 10) ? 'PreviousRoundsDiff' : 'Diff';
	
	      this.playersByClasses.order.forEach(function (className) {
	        var standing = 0,
	            prevTotalDiff = 0;
	
	        _this4.playersByClasses.byName[className].order.forEach(function (playerName) {
	          var player = _this4.playersByClasses.byName[className].byName[playerName];
	          var totalDiff = {}.toString.call(player[prop]) == '[object Object]' ? (0, _util.arraySum)(Object.values(player[prop])) : player[prop];
	
	          if (totalDiff != prevTotalDiff) standing++;
	
	          prevTotalDiff = totalDiff;
	          player.standing = standing;
	        });
	      });
	    }
	    /**
	     * Filters players by any user selected filter criteria and returns an object
	     * containing players by classes. Does not mutate this.playersByClasses by 
	     * creating a deep copy of it.
	     */
	
	  }, {
	    key: 'filterPlayers',
	    value: function filterPlayers() {
	      var _this5 = this;
	
	      var playersByClasses = (0, _util.deepCopy)(this.playersByClasses);
	      var filterMap = {
	        players: 'Name',
	        classes: 'ClassName',
	        groups: 'Group'
	      };
	
	      var isFilterActive = function isFilterActive(filterName) {
	        return filterName != 'players' ? _this5.state.filters[filterName] != 'all' : Array.isArray(_this5.state.filters.players.selected) && _this5.state.filters.players.selected.indexOf('all') < 0;
	      };
	
	      // if any of the filters is not set to "all"
	
	      var _loop = function _loop(filterName) {
	        if (isFilterActive(filterName)) {
	          playersByClasses.order.forEach(function (className) {
	            var players = playersByClasses.byName[className];
	
	            players.order = players.order.filter(function (playerName) {
	              var playerPropVal = players.byName[playerName][filterMap[filterName]];
	
	              return filterName != 'players' ? _this5.state.filters[filterName] == playerPropVal : Array.isArray(_this5.state.filters.players.selected) && _this5.state.filters.players.selected.indexOf(playerPropVal) > -1;
	            });
	            playersByClasses.byName[className] = players;
	          });
	          return 'break'; // only one filter may be active at a time
	        }
	      };
	
	      for (var filterName in this.state.filters) {
	        var _ret = _loop(filterName);
	
	        if (_ret === 'break') break;
	      }return playersByClasses;
	    }
	  }, {
	    key: 'getSubcompetitionCell',
	    value: function getSubcompetitionCell(competitionKey) {
	      var _competitionKey$split = competitionKey.split('T'),
	          _competitionKey$split2 = _slicedToArray(_competitionKey$split, 2),
	          date = _competitionKey$split2[0],
	          time = _competitionKey$split2[1];
	
	      var _date$split = date.split('-'),
	          _date$split2 = _slicedToArray(_date$split, 3),
	          y = _date$split2[0],
	          m = _date$split2[1],
	          d = _date$split2[2];
	
	      var _time$split = time.split(':'),
	          _time$split2 = _slicedToArray(_time$split, 2),
	          H = _time$split2[0],
	          i = _time$split2[1];
	
	      var competitionKeyStr = m + '/' + d + '/' + y + ' ' + H + ':' + i;
	      return (0, _snabbdomJsx.html)(
	        'td',
	        null,
	        competitionKeyStr
	      );
	    }
	  }, {
	    key: 'getScoreCell',
	    value: function getScoreCell(player, competitionKey, score, idx) {
	      var Competition = this.state.data.results.Competition;
	
	      var trackNum = (0, _util.getDeepProp)(Competition, ['Tracks', idx, 'Number']) || idx + 1;
	      var key = [Competition.ID, player.UserID || player.Name, competitionKey, 'hole-' + trackNum + 'score'].join('/');
	      var scoreClass = this.getScoreClass(score);
	      var replacements = [trackNum, score.Diff, scoreClass.title, scoreClass.isOB ? window.discgolfmetrixResults.l10n.score_tooltip_ob.replace(/&#013;/g, '\n') : ''];
	      var mIdx = -1;
	      var titleAtt = window.discgolfmetrixResults.l10n.score_tooltip.replace(/&#013;/g, '\n').replace(/%s/g, function () {
	        mIdx++;
	        return replacements[mIdx];
	      });
	      return (0, _snabbdomJsx.html)(
	        'td',
	        { key: key, className: scoreClass.class, title: titleAtt },
	        score.Result || ''
	      );
	    }
	  }, {
	    key: 'getScoreClass',
	    value: function getScoreClass(_ref3) {
	      var Result = _ref3.Result,
	          Diff = _ref3.Diff,
	          OB = _ref3.OB;
	
	      var className = void 0;
	      var isOB = !!Number(OB);
	      var obClass = isOB ? ' ob' : '';
	
	      if (typeof Result === 'undefined') className = 'no-score';else {
	        if (Result == 1) className = 'hole-in-one';else switch (Diff) {
	          case -2:
	            className = 'eagle';
	            break;
	          case -1:
	            className = 'birdie';
	            break;
	          case 0:
	            className = 'par';
	            break;
	          case 1:
	            className = 'bogey';
	            break;
	          case 2:
	            className = 'double-bogey';
	            break;
	          default:
	            className = Diff < -2 ? 'eagle' : 'fail';
	        }
	      }
	
	      return {
	        title: window.discgolfmetrixResults.l10n.score_terms[className],
	        isOB: isOB,
	        class: className + obClass
	      };
	    }
	  }, {
	    key: 'getExtraRows',
	    value: function getExtraRows(player, competitionKey, hasSubcompetitions, showPreviousRoundsSum) {
	      var _this6 = this;
	
	      var Competition = this.state.data.results.Competition;
	
	
	      return Object.keys(extras).map(function (extraKey) {
	        var key = [Competition.ID, competitionKey, player.UserID || player.Name, extraKey].join('/');
	        return (0, _snabbdomJsx.html)(
	          'tr',
	          { key: key, className: 'extra ' + extraKey.toLowerCase() },
	          (0, _snabbdomJsx.html)(
	            'td',
	            { colSpan: hasSubcompetitions ? 1 : 2 },
	            window.discgolfmetrixResults.l10n.extra[extraKey]
	          ),
	          player.PlayerResults[competitionKey].map(function (score, idx) {
	            return (0, _snabbdomJsx.html)(
	              'td',
	              { key: key + '/' + idx },
	              _this6.getExtraNotation(score, extraKey)
	            );
	          }),
	          (0, _snabbdomJsx.html)(
	            'td',
	            { colSpan: '2' },
	            player[(extraKey == 'PEN' ? 'Penalties' : extraKey) + 'Total'] || ''
	          ),
	          hasSubcompetitions || !showPreviousRoundsSum ? '' : (0, _snabbdomJsx.html)(
	            'td',
	            { colSpan: '2' },
	            player['PreviousRounds' + (extraKey == 'PEN' ? 'Penalties' : extraKey)] || ''
	          )
	        );
	      });
	    }
	  }, {
	    key: 'getExtraNotation',
	    value: function getExtraNotation(score, key) {
	      var value = parseInt(score[key], 10);
	      switch (extras[key].type) {
	        case Boolean:
	          return !!value ? '✔' : '';
	        case Number:
	        default:
	          return !!value ? value : '';
	      }
	    }
	  }]);
	
	  return ResultsTable;
	}();
	
	exports.default = ResultsTable;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(95);
	module.exports = __webpack_require__(50).Object.values;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(48);
	var $values = __webpack_require__(96)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys = __webpack_require__(70);
	var toIObject = __webpack_require__(72);
	var isEnum = __webpack_require__(97).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) if (isEnum.call(O, key = keys[i++])) {
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};


/***/ }),
/* 97 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(99);
	__webpack_require__(109);
	__webpack_require__(110);
	__webpack_require__(111);
	module.exports = __webpack_require__(50).Symbol;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(49);
	var has = __webpack_require__(62);
	var DESCRIPTORS = __webpack_require__(56);
	var $export = __webpack_require__(48);
	var redefine = __webpack_require__(61);
	var META = __webpack_require__(100).KEY;
	var $fails = __webpack_require__(57);
	var shared = __webpack_require__(79);
	var setToStringTag = __webpack_require__(82);
	var uid = __webpack_require__(63);
	var wks = __webpack_require__(83);
	var wksExt = __webpack_require__(101);
	var wksDefine = __webpack_require__(102);
	var enumKeys = __webpack_require__(103);
	var isArray = __webpack_require__(105);
	var anObject = __webpack_require__(53);
	var toIObject = __webpack_require__(72);
	var toPrimitive = __webpack_require__(59);
	var createDesc = __webpack_require__(60);
	var _create = __webpack_require__(68);
	var gOPNExt = __webpack_require__(106);
	var $GOPD = __webpack_require__(108);
	var $DP = __webpack_require__(52);
	var $keys = __webpack_require__(70);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(107).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(97).f = $propertyIsEnumerable;
	  __webpack_require__(104).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(47)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    replacer = args[1];
	    if (typeof replacer == 'function') $replacer = replacer;
	    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
	      if ($replacer) value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(51)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(63)('meta');
	var isObject = __webpack_require__(54);
	var has = __webpack_require__(62);
	var setDesc = __webpack_require__(52).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(57)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(83);


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(49);
	var core = __webpack_require__(50);
	var LIBRARY = __webpack_require__(47);
	var wksExt = __webpack_require__(101);
	var defineProperty = __webpack_require__(52).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(70);
	var gOPS = __webpack_require__(104);
	var pIE = __webpack_require__(97);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 104 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(74);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(72);
	var gOPN = __webpack_require__(107).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(71);
	var hiddenKeys = __webpack_require__(80).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(97);
	var createDesc = __webpack_require__(60);
	var toIObject = __webpack_require__(72);
	var toPrimitive = __webpack_require__(59);
	var has = __webpack_require__(62);
	var IE8_DOM_DEFINE = __webpack_require__(55);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(56) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(91);
	var test = {};
	test[__webpack_require__(83)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(61)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(102)('asyncIterator');


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(102)('observable');


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(109);
	__webpack_require__(113);
	__webpack_require__(116);
	module.exports = __webpack_require__(50).WeakMap;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(114);
	var step = __webpack_require__(115);
	var Iterators = __webpack_require__(66);
	var toIObject = __webpack_require__(72);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(46)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(83)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(51)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 115 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var each = __webpack_require__(117)(0);
	var redefine = __webpack_require__(61);
	var meta = __webpack_require__(100);
	var assign = __webpack_require__(120);
	var weak = __webpack_require__(121);
	var isObject = __webpack_require__(54);
	var fails = __webpack_require__(57);
	var validate = __webpack_require__(125);
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var tmp = {};
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(126)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(64);
	var IObject = __webpack_require__(73);
	var toObject = __webpack_require__(85);
	var toLength = __webpack_require__(76);
	var asc = __webpack_require__(118);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(119);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(54);
	var isArray = __webpack_require__(105);
	var SPECIES = __webpack_require__(83)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(70);
	var gOPS = __webpack_require__(104);
	var pIE = __webpack_require__(97);
	var toObject = __webpack_require__(85);
	var IObject = __webpack_require__(73);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(57)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(122);
	var getWeak = __webpack_require__(100).getWeak;
	var anObject = __webpack_require__(53);
	var isObject = __webpack_require__(54);
	var anInstance = __webpack_require__(123);
	var forOf = __webpack_require__(124);
	var createArrayMethod = __webpack_require__(117);
	var $has = __webpack_require__(62);
	var validate = __webpack_require__(125);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(61);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 123 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(64);
	var call = __webpack_require__(87);
	var isArrayIter = __webpack_require__(88);
	var anObject = __webpack_require__(53);
	var toLength = __webpack_require__(76);
	var getIterFn = __webpack_require__(90);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(54);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(49);
	var $export = __webpack_require__(48);
	var redefine = __webpack_require__(61);
	var redefineAll = __webpack_require__(122);
	var meta = __webpack_require__(100);
	var forOf = __webpack_require__(124);
	var anInstance = __webpack_require__(123);
	var isObject = __webpack_require__(54);
	var fails = __webpack_require__(57);
	var $iterDetect = __webpack_require__(92);
	var setToStringTag = __webpack_require__(82);
	var inheritIfRequired = __webpack_require__(127);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(54);
	var setPrototypeOf = __webpack_require__(128).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(54);
	var anObject = __webpack_require__(53);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(64)(Function.call, __webpack_require__(108).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	var VNode = __webpack_require__(9);
	var is = __webpack_require__(10);
	
	function addNS(data, children, sel) {
	  data.ns = 'http://www.w3.org/2000/svg';
	
	  if (sel !== 'foreignObject' && children !== undefined) {
	    for (var i = 0; i < children.length; ++i) {
	      addNS(children[i].data, children[i].children, children[i].sel);
	    }
	  }
	}
	
	module.exports = function h(sel, b, c) {
	  var data = {}, children, text, i;
	  if (c !== undefined) {
	    data = b;
	    if (is.array(c)) { children = c; }
	    else if (is.primitive(c)) { text = c; }
	  } else if (b !== undefined) {
	    if (is.array(b)) { children = b; }
	    else if (is.primitive(b)) { text = b; }
	    else { data = b; }
	  }
	  if (is.array(children)) {
	    for (i = 0; i < children.length; ++i) {
	      if (is.primitive(children[i])) children[i] = VNode(undefined, undefined, undefined, children[i]);
	    }
	  }
	  if (sel[0] === 's' && sel[1] === 'v' && sel[2] === 'g') {
	    addNS(data, children, sel);
	  }
	  return VNode(sel, data, children, text, undefined);
	};


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// discgolfmetrix-results.js